import React from 'react';

export function HomeIcon() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.7304 8.01002L15.1804 2.77002C13.9004 1.75002 11.9004 1.74002 10.6304 2.76002L4.08035 8.01002C3.14035 8.76002 2.57035 10.26 2.77035 11.44L4.03035 18.98C4.32035 20.67 5.89035 22 7.60035 22H18.2004C19.8904 22 21.4904 20.64 21.7804 18.97L23.0404 11.43C23.2204 10.26 22.6504 8.76002 21.7304 8.01002ZM13.6504 18C13.6504 18.41 13.3104 18.75 12.9004 18.75C12.4904 18.75 12.1504 18.41 12.1504 18V15C12.1504 14.59 12.4904 14.25 12.9004 14.25C13.3104 14.25 13.6504 14.59 13.6504 15V18Z"
        fill="currentColor"
      />
    </svg>
  );
}
